"use client"

import { Omega } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `OmegaIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const OmegaIcon = component(Icon)({ as: Omega })
